// ═══════════════════════════════════════════════════════════
//  FIREBASE INITIALISATION
//  Config values come from .env — never commit that file.
//  To activate: paste your Firebase project config into .env
// ═══════════════════════════════════════════════════════════
import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, setDoc, onSnapshot, serverTimestamp } from "firebase/firestore";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
};

// Guard: if env vars are missing (placeholders), Firebase won't be used —
// the app falls back silently to localStorage-only mode.
const isConfigured = firebaseConfig.apiKey &&
  !firebaseConfig.apiKey.startsWith("PASTE_");

let db = null;

if (isConfigured) {
  try {
    const app = initializeApp(firebaseConfig);
    db = getFirestore(app);
  } catch (e) {
    console.warn("Firebase init failed — running in offline mode:", e.message);
  }
}

export { db, isConfigured };
export { doc, getDoc, setDoc, onSnapshot, serverTimestamp };

// ── Firestore document paths ──────────────────────────────
// /app/shared  →  { visits: { pageId: count }, constants: { key: value }, updatedAt }
export const SHARED_DOC = () => isConfigured ? doc(db, "app", "shared") : null;
